"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAppVersion = void 0;
var ssrcontext_1 = require("../../ssrcontext");
var cachedGetResult_1 = require("utils/cachedGetResult");
var EzbuyAppBaseValues = (function () {
    function EzbuyAppBaseValues() {
    }
    Object.defineProperty(EzbuyAppBaseValues, "clientUAParams", {
        get: function () {
            var regex = /\[((?:[\w\d]+\/[\w\d\.\s-=,]+;?)+)\]$/i;
            var result = regex.exec(ssrcontext_1.getUserAgent());
            var ret = {};
            if (result !== null) {
                return result[1].split(";").reduce(function (pValue, cValue) {
                    var arrs = cValue.split("/");
                    if (arrs.length > 1) {
                        pValue[arrs[0]] = arrs.slice(1).join("");
                    }
                    return pValue;
                }, ret);
            }
            return ret;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EzbuyAppBaseValues, "isInEzbuyApp", {
        get: function () {
            var clientUAParams = EzbuyAppBaseValues.clientUAParams;
            return typeof clientUAParams["Type"] === "string"
                ? clientUAParams["Type"].toLowerCase() === "ezbuyint" ||
                    clientUAParams["Type"].toLowerCase() === "ezbuyapp"
                : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EzbuyAppBaseValues, "isInEzbuyAppMain", {
        get: function () {
            var clientUAParams = EzbuyAppBaseValues.clientUAParams;
            return typeof clientUAParams["Type"] === "string"
                ? clientUAParams["Type"].toLowerCase() === "ezbuyapp"
                : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EzbuyAppBaseValues, "isAndroid", {
        get: function () {
            var u = ssrcontext_1.getUserAgent();
            return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EzbuyAppBaseValues, "isIOS", {
        get: function () {
            var u = ssrcontext_1.getUserAgent();
            return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        cachedGetResult_1.default
    ], EzbuyAppBaseValues, "clientUAParams", null);
    __decorate([
        cachedGetResult_1.default
    ], EzbuyAppBaseValues, "isInEzbuyApp", null);
    __decorate([
        cachedGetResult_1.default
    ], EzbuyAppBaseValues, "isInEzbuyAppMain", null);
    __decorate([
        cachedGetResult_1.default
    ], EzbuyAppBaseValues, "isAndroid", null);
    __decorate([
        cachedGetResult_1.default
    ], EzbuyAppBaseValues, "isIOS", null);
    return EzbuyAppBaseValues;
}());
exports.checkAppVersion = function (wishVersion) {
    if (!EzbuyAppBaseValues.clientUAParams["AppVersion"]) {
        return false;
    }
    var currentAppVersion = EzbuyAppBaseValues.clientUAParams["AppVersion"];
    var versionParts = currentAppVersion.split(".");
    if (versionParts.length === 1) {
        return parseInt(currentAppVersion, 10) >= wishVersion;
    }
    var numberStr = versionParts[0] + "." + versionParts.slice(1).join("") + ";";
    return parseFloat(numberStr) >= wishVersion;
};
var EzbuyApp = (function () {
    function EzbuyApp() {
    }
    Object.defineProperty(EzbuyApp, "clientUAParams", {
        get: function () {
            return EzbuyAppBaseValues.clientUAParams;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EzbuyApp, "isInEzbuyApp", {
        get: function () {
            return EzbuyAppBaseValues.isInEzbuyApp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EzbuyApp, "isInEzbuyAppMain", {
        get: function () {
            return EzbuyAppBaseValues.isInEzbuyAppMain;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EzbuyApp, "languageCode", {
        get: function () {
            var clientUAParams = EzbuyApp.clientUAParams;
            return "" + (typeof clientUAParams["Language"] === "string"
                ? clientUAParams["Language"].replace(/-hans$/i, "").replace("zhtw", "ZhTw")
                : "en");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EzbuyApp, "isAndroid", {
        get: function () {
            return EzbuyAppBaseValues.isAndroid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EzbuyApp, "isIOS", {
        get: function () {
            return EzbuyAppBaseValues.isIOS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EzbuyApp, "isSupportBannerLink", {
        get: function () {
            return (EzbuyApp.isInEzbuyAppMain &&
                ((EzbuyApp.isAndroid && exports.checkAppVersion(201997701)) ||
                    (EzbuyApp.isAndroid && exports.checkAppVersion(201997702))));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EzbuyApp, "supportReminder", {
        get: function () {
            return (EzbuyApp.isInEzbuyApp &&
                ((EzbuyApp.isAndroid && exports.checkAppVersion(201896501)) || EzbuyApp.isIOS));
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        cachedGetResult_1.default
    ], EzbuyApp, "clientUAParams", null);
    __decorate([
        cachedGetResult_1.default
    ], EzbuyApp, "isInEzbuyApp", null);
    __decorate([
        cachedGetResult_1.default
    ], EzbuyApp, "isInEzbuyAppMain", null);
    __decorate([
        cachedGetResult_1.default
    ], EzbuyApp, "languageCode", null);
    __decorate([
        cachedGetResult_1.default
    ], EzbuyApp, "isAndroid", null);
    __decorate([
        cachedGetResult_1.default
    ], EzbuyApp, "isIOS", null);
    __decorate([
        cachedGetResult_1.default
    ], EzbuyApp, "isSupportBannerLink", null);
    __decorate([
        cachedGetResult_1.default
    ], EzbuyApp, "supportReminder", null);
    return EzbuyApp;
}());
exports.default = EzbuyApp;
